import PropTypes from "prop-types"

const InvestorShape = PropTypes.shape({
  email: PropTypes.string,
  givenName: PropTypes.string.isRequired,
  familyName: PropTypes.string.isRequired,
  mobileNumber: PropTypes.string,
  hasAccreditation: PropTypes.bool,
})

export default InvestorShape
